/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'daily-summary': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 32',
    data: '<path pid="0" d="M18 22c0-.6.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1h-8c-.6 0-1-.4-1-1zm1-12h8c.6 0 1-.4 1-1s-.4-1-1-1h-8c-.6 0-1 .4-1 1s.4 1 1 1zm0 7h8c.6 0 1-.4 1-1s-.4-1-1-1h-8c-.6 0-1 .4-1 1s.4 1 1 1zm-6 6h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1s.4 1 1 1zm0-6h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1s.4 1 1 1zm0-7h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1s.4 1 1 1zm20.7-8.8v25.2c0 3.2-2 5.5-5.1 5.5H4.8h-.1C2 31.8.3 29.4.3 26.3v-4.7c0-.6.4-1 1-1h6.4V1.2c0-.6.4-1 1-1h24c.5 0 1 .5 1 1zM4.9 29.9c1.1-.1 2-.8 2.4-1.7.2-.4.3-.8.3-1.2v-4.2H2.3v3.7c0 2 1 3.3 2.6 3.4zM31.7 2.2h-22V26.7c0 .7-.2 1.3-.4 1.9v.1l-.3.6c-.1.2-.2.4-.4.6h20c1.9 0 3.1-1.4 3.1-3.5V2.2z"/>'
  }
})
